/**
 * Zeus size guide — volume calculator + in-page anchor scroll.
 * Shared by sections/size-guide.liquid and the page-template fallback.
 */
(function () {
  function initSizeGuide(root) {
    if (!root || root.dataset.zeusSizeGuideInit === "true") return;
    root.dataset.zeusSizeGuideInit = "true";

    const weightSlider = root.querySelector("#zs-weight-slider");
    const weightValue = root.querySelector("#zs-weight-value");
    const volumeValue = root.querySelector("#zs-volume-value");
    const levelBtns = root.querySelectorAll(".zs-level-btn");
    const catalogGrid = root.querySelector("[data-zs-catalog-grid]");
    const catalogCards = Array.from(
      catalogGrid?.querySelectorAll("[data-zs-catalog-card][data-zs-volume][data-zs-available]") || [],
    ).filter((card) => !card.closest("[data-zs-static-fallback]"));
    const recommendationStatus = root.querySelector("[data-zs-recommendation-status]");
    const recommendationEmpty = root.querySelector("[data-zs-recommendation-empty]");
    let currentFactor = 1.0;

    function isAvailable(card) {
      return !["false", "0"].includes(card.dataset.zsAvailable?.toLowerCase());
    }

    function updateRecommendations(targetVolume) {
      if (!catalogGrid || !catalogCards.length) return;

      const ranked = catalogCards
        .map((card, index) => ({ card, index, volume: Number(card.dataset.zsVolume) }))
        .filter(({ volume }) => Number.isFinite(volume))
        .sort((a, b) => {
          const availability = Number(isAvailable(a.card)) - Number(isAvailable(b.card));
          if (availability) return -availability;

          const higher = Number(a.volume >= targetVolume) - Number(b.volume >= targetVolume);
          if (higher) return -higher;

          const distance = Math.abs(a.volume - targetVolume) - Math.abs(b.volume - targetVolume);
          return distance || a.index - b.index;
        });

      const visible = ranked.slice(0, 3);
      const hasEligibleCards = visible.length > 0;
      catalogCards.forEach((card) => {
        card.hidden = !visible.some(({ card: visibleCard }) => visibleCard === card);
      });
      ranked.forEach(({ card }) => catalogGrid.append(card));

      if (recommendationEmpty) recommendationEmpty.hidden = hasEligibleCards;
      if (!recommendationStatus) return;

      recommendationStatus.setAttribute("role", "status");
      recommendationStatus.setAttribute("aria-live", "polite");
      recommendationStatus.setAttribute("aria-atomic", "true");
      if (!hasEligibleCards) {
        recommendationStatus.textContent = `Aucune recommandation catalogue n’est disponible pour ${targetVolume} L.`;
      } else if (!visible.some(({ card }) => isAvailable(card))) {
        recommendationStatus.textContent = `Aucune planche disponible pour ${targetVolume} L. Les options les plus proches sont affichées.`;
      } else {
        recommendationStatus.textContent = `Les ${visible.length} recommandations les plus proches pour ${targetVolume} L sont affichées.`;
      }
    }

    function updateVolume() {
      if (!weightSlider || !volumeValue) return;
      const weight = parseInt(weightSlider.value, 10);
      const volume = Math.round(weight * currentFactor);
      if (weightValue) weightValue.textContent = weight;
      volumeValue.textContent = volume;
      updateRecommendations(volume);
    }

    if (weightSlider) {
      weightSlider.addEventListener("input", updateVolume);
      updateVolume();
    }

    levelBtns.forEach((btn) => {
      btn.addEventListener("click", function () {
        levelBtns.forEach((b) => {
          b.classList.remove("active");
          if (b.hasAttribute("aria-pressed")) b.setAttribute("aria-pressed", "false");
        });
        this.classList.add("active");
        if (this.hasAttribute("aria-pressed")) this.setAttribute("aria-pressed", "true");
        currentFactor = parseFloat(this.dataset.factor) || 1;
        updateVolume();
      });
    });

    root.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (event) {
        const href = this.getAttribute("href");
        if (!href || href === "#") return;
        const target = document.getElementById(href.slice(1));
        if (!target) return;
        event.preventDefault();
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.history.pushState(null, "", href);
        target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });

        const hadTabindex = target.hasAttribute("tabindex");
        if (!hadTabindex) target.setAttribute("tabindex", "-1");
        target.focus({ preventScroll: true });
        if (!hadTabindex) {
          target.addEventListener("blur", () => target.removeAttribute("tabindex"), { once: true });
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll(".zeus-sizing").forEach(initSizeGuide);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
